$(document).ready(function() {

   // Gestion quantité produit famille
   $('.quantity_selector .less').click(function(e){
      var $current_quantity_selector = $(this).parents('.quantity_selector').find('input').first();
      if($current_quantity_selector.val() > 0){
         $current_quantity_selector.val(parseInt($current_quantity_selector.val()) - 1);
      }

   });

   $('.quantity_selector .more').click(function(e){
      var $current_quantity_selector = $(this).parents('.quantity_selector').find('input').first();
      if($current_quantity_selector.val() < 32 && $current_quantity_selector.val() < parseInt($current_quantity_selector.data("max"))){
         $current_quantity_selector.val(parseInt($current_quantity_selector.val()) + 1);
      }
   });

   // Ajout produit famille au panier
   $('button[data-action=add-to-cart-famille]').click(function(e){
      e.preventDefault();

      var products = [];

      // Récupération du variant sélectioné
      var $selected_product = $(this).parents('.shopify-product-form').find('.product_id').first();
      var $selected_quantity = $(this).parents('.shopify-product-form').find('.quantity input').first();

      // Si un produit associé au bouton est sélectionné
      if($selected_product.length) {
         products.push({id: $selected_product.val(), quantity: $selected_quantity.val() });

         jQuery.post('/cart/add.js', {
            items: products
         }, function(){
            update_header_cart();
         }, 'json');
      }

      // Fallback : Rafraichissement de la page sans rien faire
      else window.location.href = window.location.href;

   });
});
